module.exports = __webpack_public_path__ + "static/head-bg.8f58b690.png";